import { render, staticRenderFns } from "./SimpleInput.vue?vue&type=template&id=6a880860&"
import script from "./SimpleInput.vue?vue&type=script&lang=js&"
export * from "./SimpleInput.vue?vue&type=script&lang=js&"
import style0 from "./SimpleInput.vue?vue&type=style&index=0&id=6a880860&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
